import { render, staticRenderFns } from "./CategoryLocalizationsCard.vue?vue&type=template&id=50db7020&scoped=true&"
import script from "./CategoryLocalizationsCard.vue?vue&type=script&lang=js&"
export * from "./CategoryLocalizationsCard.vue?vue&type=script&lang=js&"
import style0 from "./CategoryLocalizationsCard.vue?vue&type=style&index=0&id=50db7020&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50db7020",
  null
  
)

export default component.exports